import actions from '@/store/modules/user/actions'
import getters from '@/store/modules/user/getters'
import mutations from '@/store/modules/user/mutations'
import state from '@/store/modules/user/state'

export default {
    actions,
    getters,
    mutations,
    state
}